<template>
	<div>
		<div v-if="!isMobile && websiteInfo.desc" class="side-box-section" :class="{top:!websiteInfo.isArea}">
			<div class="box">
				<div class="title"></div>
				<div class="content">{{ websiteInfo.desc }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			websiteInfo() {
				return this.$store.state.user.websiteInfo || {}
			}
		}

	}
</script>

<style scoped>

	.side-box-section {
		position: absolute;
		top: 380px;
		left: 20px;
		bottom: 20px;
		z-index: 100;
		width: 200px;
	}

	.side-box-section.top {
		top: 100px;
	}

	.side-box-section .box{
		background: #fff;
		box-shadow: 1px 1px 10px 1px #999;
		border-radius: 4px;
		max-height: 100%;
		display: flex;
		flex-direction: column;
		min-height: 300px;

	}

	.side-box-section .title {
		height: 50px;
		background-image: url("../../../assets/images/text-xiangqing.png");
		background-size: auto 18px;
		background-repeat: no-repeat;
		background-position: center center;
		border-bottom: 1px solid #ededed;
		flex-shrink: 0;
	}

	.side-box-section .content {
		padding: 0 15px;
		line-height: 1.7;
		font-size: 13px;
		flex: 1;
		overflow-y: auto;
		margin: 20px 0;
		text-indent: 2em;
		text-align: justify;
	}
</style>